import { Annotation } from '../interfaces/annotation.interface';
import { TaskMetaInformation } from '../interfaces/task-meta-information.interface';
import { DocumentDto } from './document-dto.interface';

export interface GetTasksOfProjectDto {
    tasks: TaskMetaInformation[];
    annotations: Annotation[];
    documents: DocumentDto[];
    totalCount: number;
    currentPage: number;
}
